import { z } from 'zod';

import type { ModelHop } from './model-hop';

export const DOCPARSER_VLM_HOP_IDS = [
  'vertex-gemini',
  'vertex-claude',
  'anthropic-claude',
] as const satisfies readonly ModelHop['id'][];

export type DocparserVlmHopId = (typeof DOCPARSER_VLM_HOP_IDS)[number];

export const docparserVlmHopIdSchema = z.enum(DOCPARSER_VLM_HOP_IDS);
